import React from 'react';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';

export class ProductLeftRightEspot extends React.Component {
  render() {
    return (
      <div className='espotWrapper' id='productLeftRightEspot'>
        <div>
          {this.props.contentData.productLeftEspot ? (
            <SetInnerHTML innerHTML={this.props.contentData.productLeftEspot} />
          ) : (
            ''
          )}
        </div>
        <div>
          {this.props.contentData.productRightEspot ? (
            <SetInnerHTML innerHTML={this.props.contentData.productRightEspot} />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default ProductLeftRightEspot;
